import { render, staticRenderFns } from "./PaymentCode.vue?vue&type=template&id=3b8f01db&scoped=true&"
import script from "./PaymentCode.vue?vue&type=script&lang=js&"
export * from "./PaymentCode.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCode.vue?vue&type=style&index=0&id=3b8f01db&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8f01db",
  null
  
)

export default component.exports